import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/icons/arrow.scss';

const propTypes = {
    isLeft: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    isLeft: false,
    color: 'currentColor',
    className: null,
};

const ArrowSmall = ({ isLeft, color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="13.4px"
        height="16.1px"
        viewBox="0 0 13.4 16.1"
        xmlSpace="preserve"
        className={classNames([
            styles.container,
            { [styles.isLeft]: isLeft, [className]: className !== null },
        ])}
    >
        <g>
            <path fill={color} d="M8.5,11.1V8.2H1.3V6.8h7.2V3.9l3.6,3.6L8.5,11.1z" />
        </g>
    </svg>
);

ArrowSmall.propTypes = propTypes;
ArrowSmall.defaultProps = defaultProps;

export default ArrowSmall;
